import _ from 'lodash'
import moment from 'moment'
import Immutable from 'immutable'

//import { combineReducers } from 'redux'
import { combineReducers } from 'redux-immutable'
import { createAction, createReducer } from 'redux-act'
import { routerReducer } from 'reducers/router'
//import { pendingTasksReducer } from 'react-redux-spinner'

import auth from 'utils/auth'

export const API_REQUESTED = createAction('API_REQUESTED')
export const API_SUCCEEDED = createAction('API_SUCCEEDED')
export const API_FAILED = createAction('API_FAILED')

export const setUpdatingContent = createAction('SET_UPDATING_CONTENT')
export const setLayoutState = createAction('SET_LAYOUT_STATE')
export const setUserState = createAction('SET_USER_STATE')

export const fetchOverviewPage = createAction('FETCH_OVERVIEW_PAGE')
export const setOverviewPage = createAction('SET_OVERVIEW_PAGE')
export const setPublisherSelected = createAction('SET_PUBLISHER_SELECTED')




const initialState = Immutable.fromJS({
  from: '',
  isUpdatingContent: false,
  isLoading: false,
  activeDialog: '',
  dialogForms: {},
  submitForms: {},
  isHideLogin: false,

  // LAYOUT STATE
  layoutState: {
    isMenuTop: true,
    menuMobileOpened: false,
    menuCollapsed: false,
    menuShadow: true,
    themeLight: true,
    squaredBorders: false,
    borderLess: true,
    fixedWidth: true,
    settingsOpened: false,
  },

  // USER STATE
  userState: {
  },
  reviveState: {
    rawData: {},
    totals: {},
    summary: {},
    test: '',
    startDate: moment().subtract(30, 'days'),
    endDate: moment(),
    publisher_selected: [],
    publisher_desc: {},
    charts: {
      revenue: [],
      impressions: [],
      clicks: [],
      ctr: [],
      cpm: []
    }
  }
})


const appReducer = createReducer(
  {
  	[setUpdatingContent]: (state, isUpdatingContent) => {
      return state.mergeDeep(isUpdatingContent)
    },
    [setLayoutState]: (state, param) => {
      console.log(param)
      const newState = state.mergeDeep({ layoutState: param })
      window.localStorage.setItem('app.layoutState', JSON.stringify(newState.get('layoutState').toJS()))

      let savePublisherIds = JSON.parse(window.localStorage.getItem('publisher_selected')) || []
      if (savePublisherIds) {
        state = state.setIn(['reviveState', 'publisher_selected'], Immutable.fromJS(savePublisherIds))
      }

      return newState
    },

    [setPublisherSelected]: (state, param) => {

      window.localStorage.setItem('publisher_selected', JSON.stringify(param))
      return state

    },

    [setOverviewPage]: (state, param) => {

      const chart_data = initialState.toJS().reviveState.charts
      const chart_types = Object.keys(chart_data)
      const reviveState = state.get('reviveState').toJS()

      reviveState.summary = param.summary
      reviveState.publisher_selected = param.publisher_selected
      reviveState.publisher_desc = param.publisher_desc
      reviveState.totals = {}
      reviveState.startDate = moment(param.startDate, 'YYYY-MM-DD')
      reviveState.endDate = moment(param.endDate, 'YYYY-MM-DD')

      param = param.details

      param.forEach(entry => {
        const timestamp = moment(entry._id).unix()*1000
        const { total_clicks, total_impressions, total_revenue } = entry
        const total_types = ['impressions', 'clicks', 'revenue']

        total_types.forEach(ctype => {
          if (!reviveState.totals[ctype]) {
            reviveState.totals[ctype] = 0
          }
          reviveState.totals[ctype] += entry[`total_${ctype}`]
          chart_data[ctype].push({ x: timestamp, y: entry[`total_${ctype}`]})
        })


        let ctr = { x: timestamp, y: 0 }
        let cpm = { x: timestamp, y: 0 }


        if (total_clicks && total_impressions) {
          ctr = { x: timestamp, y: total_clicks / total_impressions }
        }

        if (total_impressions && total_revenue) {
          cpm = { x: timestamp, y: total_revenue / (total_impressions / 1000) }
        }

        chart_data['ctr'].push(ctr)
        chart_data['cpm'].push(cpm)

        entry['timestamp'] = timestamp
        entry['ctr'] = ctr.y
        entry['cpm'] = cpm.y


      })

      if (reviveState.totals['clicks'] && reviveState.totals['impressions']) {
        reviveState.totals['ctr'] = reviveState.totals['clicks'] / reviveState.totals['impressions']
      } else {
        reviveState.totals['ctr'] = 0
      }

      if (reviveState.totals['revenue'] && reviveState.totals['impressions']) {
        reviveState.totals['cpm'] = reviveState.totals['revenue'] / (reviveState.totals['impressions'] / 1000)
      } else {
        reviveState.totals['cpm'] = 0
      }

      chart_types.forEach(ctype => {
        chart_data[ctype].sort(function(a, b) {
          return a.x - b.x;
        })
      })

      param = _.keyBy(param, '_id')
      reviveState.rawData = { ...param }
      reviveState.charts = chart_data

      window.localStorage.setItem('publisher_selected', JSON.stringify(reviveState.publisher_selected))

      return state.set('reviveState', Immutable.fromJS(reviveState))

    },

    [setUserState]: (state, user) => {
      console.log('setUserState', user)

      let userState = {}

      if (user.jwt && user.user) {
        auth.setToken(user.jwt)
        auth.setUserInfo(user.user)
        userState = { ...user.user, jwt:user.jwt }
      } else {
        auth.clearAppStorage()
        userState = {}
      }

      return state.mergeDeep({userState: userState})
    }

  },
  initialState,
)


export default combineReducers({
  routing: routerReducer,
  app: appReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js